import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './Pages/Home'; // Import your Home component
import './App.css';
import About from './Pages/About';
import Contact from './Pages/Contact';
import Chatbot from './Pages/Chatbot';
import BackToTopButton from './Components/BackToTopButton/BackToTopButton';
import Projects from './Pages/projects';

const App = () => {
  return (
    <Router>
      <div className="App">
      <BackToTopButton/>
        <div className="content">
          <Routes>
            <Route exact path="/" element={<Home />} />
            <Route exact path="/about" element={<About />} />
            <Route exact path='/project' element={<Projects/>}/>
            <Route exact path="/contact" element={<Contact />} />
            <Route exact path="/chatbot" element={<Chatbot />} />
          </Routes>
        </div>

      </div>
    </Router>
  );
}

export default App;